import { useEffect, useState } from "react";
import ButtonCustom from "./ButtonCustom";
import { withStyles } from '@material-ui/core/styles';
import { withTranslation } from 'react-i18next'
import { Grid } from "@material-ui/core";
import { ArrowDownIcon, CheckIcon, DeleteIcon, DeleteWhiteIcon, PaypalIcon } from "./icons";
import CustomizedCircularProgress from "./CircularProgress";
import crmservices from "../wsclient";
import client from 'braintree-web/client'
import checkout from 'braintree-web/paypal-checkout'
import braintree from 'braintree-web'
import { getContacts } from "../utils/common";
import CustomTypo from "./CustomTypo";
import { connection, domainName } from "../../portal.config";

// accountt 
// sb-zohys7237983@business.example.com
// M;SB31?x
// EJ37VS8BQHJVA
// sb-2vtnz7239030@personal.example.com
// 0pB{^r7P
// RB7JN2DTVU566
// sb-xtymq7240364@personal.example.com
// 2Oasr!Sz
// 5Z3ABHFRWGEMY

function Paypal(props) {
	const [clientToken, setClientToken] = useState(null);
	const [showLoading, onShowLoading] = useState(false);
	const [paypals, setPayPal] = useState(props.paypals);
	const contact = getContacts();
	const { classes, t } = props
	useEffect(() => {
		getClientToken();
	}, [])
	
	useEffect(() => {
		setPayPal(props.paypals)
	}, [props.paypals])

	const getClientToken = async () => {
		onShowLoading(true);
		try {
			let paypalIntegrationId = connection.crmConfig.paypalIntegration;
			let result = await crmservices.paymentgateway.getClientToken({ integration_id: paypalIntegrationId });
			console.log('getClientToken result===', result)
			if (result && result.code == 'OK' && result.data && result.data.client_token) {
				let clientToken = result.data.client_token;
				let clientInstance = await client.create({ authorization: clientToken })
				console.log(' creating client clientInstance:', clientInstance);
				if (clientInstance) {
					let paypalCheckoutInstance = await checkout.create({ client: clientInstance })
					console.log(' creating PayPal paypalCheckoutInstance:', paypalCheckoutInstance);
					window.paypal.Button.render({
						env: 'sandbox', // or 'sandbox'

						locale: 'en_US',
						//fundingSource: window.paypal.FUNDING.PAYPAL,
						payment: function () {
							return paypalCheckoutInstance.createPayment({
								flow: 'vault',
							});
						},

						onAuthorize: function (data, actions) {
							return paypalCheckoutInstance.tokenizePayment(data).then(async function (payload) {

								console.log('onAuthorize payload====', payload)
								if (payload.nonce) {
									await onAddPaymentMethod(payload);
									//let response = await fetch(url + 'transactions/sale', options);
								}
								// Submit payload.nonce to your server
							});
						},

						onCancel: function (data) {
							console.log('checkout.js payment cancelled', JSON.stringify(data, 0, 2));
						},

						onError: function (err) {
							console.error('checkout.js error', err);
						}
					}, '#paypal-button'); // the PayPal button will be rendered in an html element with the id `paypal-button`) 

					//})

				}
			}
		}
		catch (e) {
			onShowLoading(false)
			console.log('getClientToken error: ', e)
		}

		onShowLoading(false)
	}

	const onAddPaymentMethod = async (payload) => {
		console.log("payload:", payload);
		let paypalIntegrationId = connection.crmConfig.paypalIntegration;
		let detail = payload.details ? payload.details : {};
		let createCustomerResult = await crmservices.paymentgateway.addPaymentMethod({
			integration_id: paypalIntegrationId,
			email: detail.email ? detail.email : '',
			payment_method_nonce_token: payload.nonce,
		});
		console.log('createCustomerResult ===', createCustomerResult)
		if (createCustomerResult.code === 'OK') {
			let paymentMethod = await props.onRefresh();
			setPayPal(paymentMethod)
		}
		else if (createCustomerResult.code === 'CUSTOMER_EMAIL_ALREADY_EXIST') {
			props.showMessage(true, t('CUSTOMER_EMAIL_ALREADY_EXIST'))
		}
		else {
			props.showMessage(true, t('EXCEPTION_PROCESS'))
		}
	}

	const onRemoveCard = async (item) => {
		onShowLoading(true)
		try {
			let removePaymentMethod = await crmservices.paymentgateway.removePaymentMethod({payment_method_id: item.id});
			if (removePaymentMethod.code == 'OK') {
				let paymentMethod = await props.onRefresh();
				setPayPal(paymentMethod)
				// if (paymentMethod.length == 0){
				// 	await getClientToken()
				// }
			}
		}
		catch (e) {
			onShowLoading(false)
		}
		onShowLoading(false)
	}
	console.log('paypals===', paypals)
	return (
		<Grid item container justify='center' className={classes.container}>
			<Grid item xs={12}>
				<CustomTypo mg_left_sm variant='caption1' color='onPrimary'>{'Your Paypal'}</CustomTypo>
			</Grid>
			<Grid item xs={12}>
				{showLoading && <CustomizedCircularProgress />}
			</Grid>
			{paypals.length > 0 && paypals.map((item, index) => <CardItem key={index} item={item} classes={classes} setPrimaryCard={props.setPrimaryCard} onRemoveCard={onRemoveCard} />)}
			<Grid xs={12} item className={classes.button_add} container justify='center'>
				<div id="paypal-button"></div>
			</Grid>
		</Grid>
	)
}
function CardItem(props) {
	const { classes, item } = props
	return (
		<Grid xs={12} item container className={classes.method_container}>
			<Grid xs={11} item className={classes.method_pre}>
				<Grid item className={classes.method} container alignItems='center' onClick={() => props.setPrimaryCard(item.id)}>
					<Grid xs={10} item>
						<PaypalIcon style={{width:80,height:40,objectFit:'contain'}}/>
						<CustomTypo variant='body1'> {item.wallet && item.wallet.email ? item.wallet.email : ''}</CustomTypo>
					</Grid>
					{item.is_primary && <Grid xs={2} item container justify='flex-end' >
						<CheckIcon />
					</Grid>}
				</Grid>
			</Grid>
			<Grid xs={1} item container justify='flex-end' alignItems='center'>
				<div className={classes.bg_icon} onClick={() => props.onRemoveCard(item)}>
					<DeleteWhiteIcon />
				</div>
			</Grid>
		</Grid>
	)
}
const styles = theme => ({
	container: {
		marginTop: theme.spacing(8)
	},
	method_container: {
		padding: theme.spacing(4, 0, 0, 0)
	},
	method_pre: {
		padding: theme.spacing(0, 2, 0, 0)
	},
	method: {
		backgroundColor: theme.palette.background.secondary,
		borderRadius: theme.spacing(2),
		// height: theme.spacing(12),
		padding: theme.spacing(1, 4, 1, 4),
		cursor: 'pointer',
		[theme.breakpoints.down('xs')]: {
			padding: theme.spacing(1, 2, 1, 2),
		}
	},
	button_add: {
		marginTop: theme.spacing(10)
	},
	bg_icon: {
		width: theme.spacing(6),
		height: theme.spacing(6),
		borderRadius: theme.spacing(6),
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		backgroundColor: theme.palette.icon.trash,
		cursor: "pointer",
		touchAction: "manipulation",
	}
});
export default withStyles(styles)(withTranslation()(Paypal));